import type { SummaryTone } from '@/features/Vacations/utils/vacationSummaryColumns';

const TONE_CLASSES: Record<SummaryTone, string> = {
  default: 'text-gray-900',
  muted: 'text-gray-400 italic',
  accruing: 'text-amber-600',
  success: 'text-green-700',
  warning: 'text-amber-700',
  danger: 'text-red-600',
};

const CAPTION_CLASSES: Record<SummaryTone, string> = {
  default: 'text-gray-500',
  muted: 'text-gray-400',
  accruing: 'text-amber-600',
  success: 'text-green-700',
  warning: 'text-amber-700',
  danger: 'text-red-600',
};

export interface VacationSummaryCellProps {
  display: string;
  caption?: string;
  tone: SummaryTone;
  tooltip?: string;
}

export function VacationSummaryCell({ display, caption, tone, tooltip }: VacationSummaryCellProps) {
  return (
    <div className="text-sm" title={tooltip}>
      <span className={TONE_CLASSES[tone]}>{display}</span>
      {caption && <div className={`text-xs ${CAPTION_CLASSES[tone]}`}>{caption}</div>}
    </div>
  );
}
